import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavStudent({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.627 7.998a2.697 2.697 0 002.698-2.7A2.697 2.697 0 005.627 2.6a2.697 2.697 0 00-2.7 2.699 2.697 2.697 0 002.7 2.699zm1.85.77h-.2a3.796 3.796 0 01-1.65.386 3.804 3.804 0 01-1.651-.385h-.2A2.777 2.777 0 001 11.545v.694c0 .638.518 1.156 1.157 1.156h6.94c.638 0 1.156-.518 1.156-1.156v-.694a2.777 2.777 0 00-2.776-2.776zM9.8 5a.9.9 0 01.9-.9h3.5a.9.9 0 010 1.8h-3.5a.9.9 0 01-.9-.9zm1 3a.9.9 0 01.9-.9h2.5a.9.9 0 010 1.8h-2.5a.9.9 0 01-.9-.9zm1 3a.9.9 0 01.9-.9h1.5a.9.9 0 010 1.8h-1.5a.9.9 0 01-.9-.9z"
      />
    </svg>
  );
}

SvgNavStudent.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavStudent.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavStudent svgRef={ref} {...props} />);
export default ForwardRef;
